<div *ngIf="!finished">{{ label }}</div>

<div class="input-group mb-3" *ngIf="!finished">
  <input type="text" class="form-control" placeholder="Enter e-mail address" aria-label="Recipient's username" aria-describedby="basic-addon2" [(ngModel)]="email">
  <div class="input-group-append">
    <button class="btn btn-outline-secondary" type="button" (click)="saveEmail()">Submit</button>
  </div>
</div>

<div class="message">{{ message }}</div>